module.exports = __webpack_public_path__ + "img/qy-rz.106b4d4e.svg";